import 'core-js/es6/map';
import 'core-js/es6/set';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {HashRouter, Route, Switch, BrowserRouter} from 'react-router-dom';

// Styles
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import '../scss/style.scss'
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss'

// Containers
//import Login from './views/Login';

import Full from './containers/Full';
import createStore from './redux/createStore';

const store = createStore();

ReactDOM.render(
  <Provider store={store}>
     <BrowserRouter>
        <Full />
     </BrowserRouter>
  </Provider>
  , document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js